import { PieChartDataItem } from '../components/DataPieChart'
import { colorPalette } from './helpers'

interface ApiTrackerCategory {
  category?: {
    code?: string
    name?: string
  }
  trackerCount?: number
  trackers?: Array<{ name: string }>
}

interface ApiTrackerData {
  categories?: ApiTrackerCategory[]
  total?: number
}

interface ProcessedCategory {
  name: string
  count: number
  trackers: Array<{ name: string }>
  code: string
}

interface ExtendedPieChartDataItem extends PieChartDataItem {
  code?: string
}

export const transformTrackerCategoriesData = (data: ApiTrackerData | unknown): ExtendedPieChartDataItem[] => {
  const trackerData = data as ApiTrackerData

  if (
    !trackerData ||
    !trackerData.categories ||
    !Array.isArray(trackerData.categories) ||
    trackerData.categories.length === 0
  ) {
    return []
  }

  const calculatedTotal = trackerData.categories.reduce(
    (sum: number, item: ApiTrackerCategory) => sum + (item.trackerCount || 0),
    0,
  )

  const total: number = typeof trackerData.total === 'number' ? trackerData.total : calculatedTotal

  if (total === 0) return []

  const TOP_CATEGORIES_COUNT = 5

  const processed = trackerData.categories
    .reduce((result: ProcessedCategory[], item: ApiTrackerCategory) => {
      const count = item.trackerCount || 0

      if (count > 0) {
        result.push({
          name: item.category?.name || '',
          count,
          trackers: item.trackers || [],
          code: item.category?.code || '',
        })
      }

      return result
    }, [])
    .sort((a: ProcessedCategory, b: ProcessedCategory) => b.count - a.count)

  const mainCategories: ExtendedPieChartDataItem[] = []
  const othersGroup: ProcessedCategory[] = []

  processed.forEach((item: ProcessedCategory, index: number) => {
    if (index < TOP_CATEGORIES_COUNT) {
      mainCategories.push({
        name: item.name,
        value: Number(((item.count / total) * 100).toFixed(1)),
        color: colorPalette[index % colorPalette.length],
        originalCount: item.count,
        code: item.code,
      })
    } else {
      othersGroup.push(item)
    }
  })

  if (othersGroup.length > 0) {
    const othersTotal = othersGroup.reduce((sum, item) => sum + item.count, 0)
    const othersPercentage = (othersTotal / total) * 100

    const subCategories = othersGroup.map(item => ({
      name: item.name,
      count: item.count,
      percentage: Number(((item.count / total) * 100).toFixed(1)),
    }))

    mainCategories.push({
      name: 'Others',
      value: Number(othersPercentage.toFixed(1)),
      color: colorPalette[mainCategories.length % colorPalette.length],
      originalCount: othersTotal,
      subCategories,
    })
  }

  return mainCategories
}
